import { SharedModule } from "./shared/shared.module";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule, AppPreloadingStrategy } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { AuthcrudInterceptorService } from "./auth/auth-crud-interceptor.service";
import { StoreModule } from "@ngrx/store";
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';

import {
  invoiceReducer,
  invoiceSelectedReducer,
} from "./store/reducers/invoice.reducer";
import { subscriptionReducer } from "./store/reducers/subscription.reducer";
import { userReducer } from "./store/reducers/user.reducer";
import { departmentReducer } from "./store/reducers/department.reducer"; 

import { CustomerSurveyComponent } from "./customer-survey/customer-survey.component";

// ANGULAR OFFICE 365
import { MsalModule } from "@azure/msal-angular";
import { Office365OuthSettings } from "../environments/environment";


//
import { SettingsGuard } from "./settings/settings.guard";
import { NgxSpinnerModule } from "ngx-spinner";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { TimepickerModule } from "ngx-bootstrap/timepicker";
import { ToastrModule } from "ngx-toastr";
import { CurrencyPipe } from "@angular/common";
import { ReportsModule } from './reports/reports.module';
import { PaginationModule } from "ngx-bootstrap/pagination";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { CallsLookupComponent } from './calls-lookup/calls-lookup.component'
import { InternalResponseViewTicketComponent } from "./ticket/internal-response-view-ticket/internal-response-view.component";
import { TicketViewChatsComponent } from "./ticket/ticket-view/ticket-view-chats/ticket-view-chats.component";
import { TkNoteTextareaComponent } from "./ticket/ticket-view/textareas/notes/tk-note-textarea/tk-note-textarea.component";
import { TicketCallLogComponent } from "./ticket/ticket-view/textareas/ticket-call-log/ticket-call-log.component";
import { QuillModule } from 'ngx-quill';
import { InternalResponseTicketViewChatsComponent } from "./ticket/internal-response-view-ticket/ticket-view-chats/ticket-view-chats.component";
import { InternalResponseTkAllNotesComponent } from "./ticket/internal-response-view-ticket/tk-all-notes/tk-all-notes.component";

/** */
export const protectedResourceMap: [string, string[]][] = [
  ["https://graph.microsoft.com/v1.0/me", ["user.read"]],
];
const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;

// Modules
@NgModule({
  declarations: [AppComponent, CustomerSurveyComponent, CallsLookupComponent, InternalResponseViewTicketComponent, InternalResponseTicketViewChatsComponent, InternalResponseTkAllNotesComponent],//, TicketViewChatsComponent, TicketCallLogComponent

  imports: [
    BrowserModule,
    QuillModule.forRoot(),
    FormsModule,
    SharedModule,
    HttpClientModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgIdleKeepaliveModule.forRoot(),
    PaginationModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    NgxSpinnerModule,
    TooltipModule.forRoot(),
    StoreModule.forRoot({
      invoice: invoiceReducer,
      subscription: subscriptionReducer,
      selectedInvoice: invoiceSelectedReducer,
      userInfo: userReducer,
      departmentInfo: departmentReducer
    }),
    // Instrumentation must be imported after importing StoreModule (config is optional)
    // StoreDevtoolsModule.instrument({
    //   maxAge: 25, // Retains last 25 states
    //   logOnly: environment.production, // Restrict extension to log-only mode
    // }),
    // Microsoft Azure
    MsalModule.forRoot(
      {
        auth: {
          clientId: Office365OuthSettings.appId,
          authority: Office365OuthSettings.authority,
          validateAuthority: true,
          redirectUri: Office365OuthSettings.redirectUri,
          navigateToLoginRequestUrl: true,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: isIE, // set to true for IE 11,
        },
      },
      {
        popUp: !isIE,
        consentScopes: Office365OuthSettings.scopes,
        extraQueryParameters: {},
      }
    ),
    ToastrModule.forRoot({
      timeOut: 10000,
      preventDuplicates: true,
    }),
    BsDatepickerModule.forRoot(),
    TimepickerModule.forRoot()
  ],

  providers: [
    AppPreloadingStrategy,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthcrudInterceptorService,
      multi: true,
    },
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: ErrorInterceptor,
    //   multi: true,
    // },
    SettingsGuard,
    CurrencyPipe,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
